import React from 'react';
import {Container} from 'react-bootstrap';
import FoodCategoryTabs from '../FoodCategoryTabs';


const Packages = () => {
  return (
    <section className="sp-cnt-blk">
      <Container>
        <FoodCategoryTabs />
      </Container>
    </section>      
  )
}

export default Packages